import { render, staticRenderFns } from "./DpSubscribeMonth.vue?vue&type=template&id=3827f0da"
import script from "./DpSubscribeMonth.vue?vue&type=script&lang=js"
export * from "./DpSubscribeMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports